import { Button, ButtonProps, Card, Text } from "@ttc3k/trekker";
import { Xmark } from "iconoir-react";
import { ReactNode, useState } from "react";
import { Collapsible } from "shared/components";
import { Flex } from "styled-system/jsx";
import { JsxStyleProps } from "styled-system/types";

interface ActionCardProps {
  title?: string;
  subText?: string | ReactNode;
  buttonProps?: ButtonProps;
  surfaceProps?: JsxStyleProps;
  bodyProps?: JsxStyleProps;
  textProps?: JsxStyleProps;
  displayCloseButton?: boolean;
}

export const ActionCard = ({
  title,
  subText,
  buttonProps,
  surfaceProps,
  bodyProps,
  textProps,
  displayCloseButton = false,
}: ActionCardProps) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Collapsible open={isOpen}>
      <Card.Surface {...surfaceProps} position={"relative"}>
        <Card.Body {...bodyProps} pr={displayCloseButton ? "500" : undefined}>
          <Card.BodyContent>
            <Flex flexDir={"column"} gap={"75"}>
              {title && (
                <Text visual={"bodySemiBold"} {...textProps}>
                  {title}
                </Text>
              )}
              {subText && (
                <Text visual={"bodyRegular"} {...textProps}>
                  {subText}
                </Text>
              )}
            </Flex>

            {displayCloseButton && (
              <Button
                Icon={Xmark}
                visual={"unstyled"}
                padding={0}
                position={"absolute"}
                top={"200"}
                right={"200"}
                transitionDuration={"normal"}
                transitionProperty={"color"}
                transitionTimingFunction={"default"}
                color={"icon.mid"}
                _hover={{ color: "icon.dark" }}
                onClick={() => setIsOpen(false)}
              />
            )}

            {buttonProps && (
              <Button
                type={"button"}
                alignSelf={"center"}
                minW={"fit-content"}
                {...buttonProps}
              />
            )}
          </Card.BodyContent>
        </Card.Body>
      </Card.Surface>
    </Collapsible>
  );
};
